import axios from "axios"

export default {
	getProfiles() {
		return axios.get(`/v1/profiles`)
	},

	getContextProfiles() {
		return axios.get(`/v1/context/profiles`)
	},

	getContextProfilesInProgress() {
		return axios.get(`/v1/context/profile_prog`)
	},

	getUserProfiles(sectionID, userID) {
		return axios.get(`/v1/profiles/user/${sectionID}/${userID}`)
	},

	getSectionProfiles(sectionID) {
		return axios.get(`/v1/profiles/section/${sectionID}`)
	},

	getNoTeamProfiles(sectionID) {
		return axios.get(`/v1/profiles/no_team/${sectionID}`)
	},

	getHasTeamProfiles(sectionID) {
		return axios.get(`/v1/profiles/has_team/${sectionID}`)
	},

	getTeamProfiles(sectionID, teamID) {
		return axios.get(`/v1/profiles/team/${sectionID}/${teamID}`)
	},

	getProfile(userID, assignmentID) {
		return axios.get(`/v1/profile/${userID}/${assignmentID}`)
	},

	getUserProfile(assignmentID) {
		return axios.get(`/v1/profile/mine/${assignmentID}`)
	},

	getProfileInProgress(assignmentID) {
		return axios.get(`/v1/profile_prog/mine/${assignmentID}`)
	},

	saveProfile(profile) {
		return axios.post(`/v1/profiles`, profile)
	},

	saveProfileInProgress(profile) {
		return axios.post(`/v1/profile_prog`, profile)
	}
}